import React, { Component, Fragment } from 'react';
import { debounce } from 'debounce';
import shortid from 'shortid';
import RoundClose from 'react-md-icon/dist/RoundClose';

import CustomDate from 'types/date';
import { Card, CardBody } from 'components/common/card';
import Button from 'components/common/button';
import Input from 'components/common/input';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableHeadCell,
} from 'components/common/table';
import Loader from 'components/common/loader';
import toast from 'components/common/toast';
import confirmation from 'components/common/confirmation';

import { VALIDATE_PRODUCT, CREATE_LOCATION_COUNTING } from '../../requests';

import { Top, Bottom, RemoveButton, Label } from './elements';

class LocationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: {},
      products: props.latestProducts,
      editRow: false,
      idProductValid: false,
      loading: false,
      loadingCreate: false,
      productToEditIndex: null,
    };
  }

  handleChangeNext = e => {
    const {
      target: { name },
    } = e;

    const isEnter = e.key === 'Enter';

    if (isEnter) {
      const nextElement = this.refs[Number(name) + 1];

      if (nextElement.id) {
        document.getElementById(nextElement.id).click();
        return;
      }

      const { props } = nextElement;
      document.getElementById(props.id).focus();
    }
  };

  handleUpcInputFocus = () => {
    const upcInput = document.getElementById('upc');
    upcInput.focus();
  }

  handleInput = async e => {
    const { product } = this.state;

    const {
      target: { id },
    } = e;
    let {
      target: { value },
    } = e;

    if (id === 'boxes' || id === 'pieces') {
      value = value.replace(/[^0-9]/g, '');
    }

    if (id === 'upc' && value.length > 0) {
      await this.validateProduct(value);
    }

    if (id === 'upc' && value.length === 0) {
      this.setState({ product: {} });
      return;
    }

    if (value.length === 0) {
      delete product[id];
      this.setState({ product });
      return;
    }

    this.setState({ product: { ...product, [id]: value } });
  };

  formatDate = date => {
    let isoDate = [];
    isoDate[0] = date.split('/')[1];
    isoDate[1] = date.split('/')[0];
    isoDate[2] = date.split('/')[2];
    isoDate = isoDate.join('/');

    return new CustomDate(new Date(isoDate)).startOf('day').format();
  };

  isProductInProducts = (product, indexOfProductToEdit) => {
    const { products } = this.state;

    return products.some((pro, index) => {
      const isEqual = `${pro.upc}${pro.batch}${pro.expiryDate ? new CustomDate(pro.expiryDate).format('DD/MM/YYYY') : ''}` === `${product.upc}${product.batch}${product.expiryDate}`;
      return isEqual && index !== indexOfProductToEdit;
    });
  };

  getTotalPieces = product => {
    const { boxes, piecesPerBox, pieces } = product;

    return Number(piecesPerBox) * Number(boxes) + Number(pieces);
  };

  addRow = () => {
    const { product, products } = this.state;
    const { expiryDate } = product;

    const dateRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i;
    const isDateValid = dateRegex.test(expiryDate);

    if (this.isProductInProducts(product)) {
      toast.error('Este producto ya se encuentra en la tabla');
      this.setState({ product: {} });
      return;
    }

    if (!isDateValid) {
      toast.info('El formato de la fecha debe ser DD/MM/AAAA y/o una fecha válida');
      return;
    }

    const isoDate = this.formatDate(expiryDate);
    const totalPieces = this.getTotalPieces(product);
    const productToAdd = { ...product, expiryDate: isoDate, totalPieces };

    this.setState({ products: [...products, productToAdd], product: {} });

    this.handleUpcInputFocus();
    toast.success('Producto agregado');
  };

  updateRow = () => {
    const { product, products, productToEditIndex } = this.state;

    const productsCopy = [...products];
    const { expiryDate } = product;
    const totalPieces = this.getTotalPieces(product);

    const dateRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i;
    const isDateValid = dateRegex.test(expiryDate);

    if (this.isProductInProducts(product, productToEditIndex)) {
      toast.error('Este producto ya se encuentra en la tabla');
      return;
    }

    if (!isDateValid) {
      toast.info('El formato de la fecha debe ser DD/MM/AAAA y/o una fecha válida');
      return;
    }

    const isoDate = this.formatDate(expiryDate);

    productsCopy[productToEditIndex] = { ...product, totalPieces, expiryDate: isoDate };

    this.setState({
      products: productsCopy,
      product: {},
      editRow: false,
      productToEditIndex: null,
    });

    toast.success('Producto actualizado');
    this.handleUpcInputFocus();
  };

  deleteRow = async index => {
    const { products } = this.state;

    if (await confirmation('¿Estás seguro?')) {
      const productsCopy = [...products];
      productsCopy.splice(index, 1);

      this.setState({ products: productsCopy });
    }
  };

  selectRow = (product, index) => {
    let productCopy = {
      ...product,
    };

    if (product.expiryDate) {
      productCopy.expiryDate = new CustomDate(product.expiryDate).format('DD/MM/YYYY');
    }

    this.setState({ product: productCopy, editRow: true, productToEditIndex: index });
  };

  cancelSelectedRow = () =>
    this.setState({ product: {}, editRow: false, productToEditIndex: null });

  validateProduct = debounce(async upc => {
    const { client } = this.props;

    this.setState({ loading: true });

    const { data, errors } = await client.query({
      query: VALIDATE_PRODUCT,
      variables: { upc },
    });

    if (errors) {
      toast.error('UPC no encontrado o inexistente');
      this.setState({ loading: false, product: {} });

      return;
    }

    const {
      validateProduct: { productCode, pieces },
    } = data;

    toast.success('Código encontrado');

    this.setState({
      idProductValid: true,
      product: { productCode, upc, piecesPerBox: pieces },
      loading: false,
    });
  }, 300);

  createLocationCounting = async () => {
    const { client, changeSlide, location } = this.props;
    const { products } = this.state;

    const metadata = {
      locationTag: location.location.tag,
      products: products.map(product => {
        product.pieces = Number(product.piecesPerBox);
        product.boxes = Number(product.boxes);
        product.totalPieces = Number(product.totalPieces);

        delete product.piecesPerBox;
        return product;
      }),
    };

    if (await confirmation('¿Estás seguro?')) {
      this.setState({ loadingCreate: true });

      const { errors } = await client.mutate({
        mutation: CREATE_LOCATION_COUNTING,
        variables: {
          data: metadata,
        },
      });

      if (errors) {
        const [error] = errors;
        let toastMessage = 'Algo salió mal, intentalo de nuevo';

        if (error && error.includes('location is not enabled')) {
          toastMessage = 'Esta ubicación ya ha sido cerrada';
        }

        if (error && error.includes('is already part of the matched products')) {
          const productRegistered = error.split('code')[1].split(' ')[1];

          toast.info(`El producto ${productRegistered} ya ha sido registrado`);
          this.setState({ loadingCreate: false });
          return;
        }

        toast.error(toastMessage);
        this.setState({ loadingCreate: false });
        return;
      }

      this.setState({ loadingCreate: false });
      changeSlide(1);
      toast.success('Conteo realizado con éxito');
    }
  };

  hasAllFields = product => {
    const requiredFields = ['upc', 'boxes', 'pieces', 'batch', 'productCode', 'expiryDate'];

    const hasFields = requiredFields.filter(key => !product[key]);

    return hasFields.length === 0;
  };

  canSubmitTable = () => {
    const { products } = this.state;
    const { location } = this.props;

    if (location.versions >= 2 && !products.length) {
      return true;
    }

    return products.every(product => this.hasAllFields(product));
  };

  render() {
    const { product, products, editRow, loading, loadingCreate } = this.state;
    const { changeSlide, clearLatestProducts, openReport } = this.props;
    const formCompleted = this.hasAllFields(product);
    const submitDisabled = !this.canSubmitTable();

    return (
      <Fragment>
        <Card showOverflow>
          <CardBody>
            <Label>Etiqueta: {openReport.label}</Label>
            <Top editRow={editRow}>
              <Input
                input
                type="text"
                label="Código del producto"
                primary
                onKeyPress={this.handleChangeNext}
                onChange={this.handleInput}
                value={product.productCode || ''}
                disabled
              />
              <Input
                input
                type="text"
                label="Piezas por caja"
                primary
                onKeyPress={this.handleChangeNext}
                onChange={this.handleInput}
                value={product.piecesPerBox || ''}
                disabled
              />
              <Input
                input
                type="text"
                label="UPC"
                primary
                onKeyPress={this.handleChangeNext}
                onChange={this.handleInput}
                value={product.upc || ''}
                disabled={editRow}
                ref="1"
                name="1"
                id="upc"
              />
              <Input
                input
                type="text"
                label="Lote"
                primary
                onKeyPress={this.handleChangeNext}
                onChange={this.handleInput}
                value={product.batch || ''}
                ref="2"
                name="2"
                id="batch"
              />
              <Input
                input
                type="text"
                min="0"
                label="Número de cajas"
                primary
                onKeyPress={this.handleChangeNext}
                onChange={this.handleInput}
                value={product.boxes || ''}
                ref="3"
                name="3"
                id="boxes"
              />
              <Input
                input
                type="text"
                min="0"
                label="Número de piezas"
                primary
                onKeyPress={this.handleChangeNext}
                onChange={this.handleInput}
                value={product.pieces || ''}
                ref="4"
                name="4"
                id="pieces"
              />
              <Input
                input
                type="text"
                label="Fecha de caducidad"
                id="expiryDate"
                primary
                ref="5"
                name="5"
                onKeyPress={this.handleChangeNext}
                onChange={this.handleInput}
                value={product.expiryDate || ''}
              />
              <div className="buttons-form">
                {editRow && (
                  <Button sm danger marginR="20" onClick={this.cancelSelectedRow}>
                    Cancelar
                  </Button>
                )}
                <Button
                  ref="6"
                  sm
                  type="button"
                  id="product-button"
                  onClick={() => (editRow ? this.updateRow() : this.addRow())}
                  not={!formCompleted}
                  disabled={!formCompleted}
                >
                  {loading
                    ? <Loader inverse size="24" /> 
                    : editRow ? 'Actualizar' : 'Agregar'}
                </Button>
              </div>
            </Top>
            <Bottom>
              <Button sym marginR="20" onClick={() => {
                changeSlide(1);
                clearLatestProducts();
              }} inverse>
                Volver a lista de ubicaciones
              </Button>
              {loadingCreate ? (
                <Loader> </Loader>
              ) : (
                <Button
                  sm
                  not={submitDisabled}
                  disabled={submitDisabled}
                  onClick={this.createLocationCounting}
                >
                  Terminar y guardar
                </Button>
              )}
            </Bottom>
          </CardBody>
        </Card>
        <Card marginT="40">
          <CardBody>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>Código</TableHeadCell>
                    <TableHeadCell>Lote</TableHeadCell>
                    <TableHeadCell>UPC</TableHeadCell>
                    <TableHeadCell>Fecha caducidad</TableHeadCell>
                    <TableHeadCell># Cajas</TableHeadCell>
                    <TableHeadCell># Piezas</TableHeadCell>
                    <TableHeadCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {products.map((product, index) => {
                    const { productCode, batch, upc, expiryDate, boxes, pieces } = product;
                    let batchColor = 'danger';

                    if (batch && batch.toUpperCase().includes(productCode.toUpperCase())) {
                      batchColor = 'success';
                    }

                    return (
                      <TableRow key={shortid.generate()} clickable hover>
                        <TableCell onClick={() => this.selectRow(product, index)}>
                          {productCode}
                        </TableCell>
                        <TableCell
                          onClick={() => this.selectRow(product, index)}
                          color={batchColor}
                        >
                          {batch}
                        </TableCell>
                        <TableCell onClick={() => this.selectRow(product, index)}>{upc}</TableCell>
                        <TableCell onClick={() => this.selectRow(product, index)}>
                          {expiryDate ? new CustomDate(expiryDate).format('ll') : ''}
                        </TableCell>
                        <TableCell onClick={() => this.selectRow(product, index)}>
                          {boxes}
                        </TableCell>
                        <TableCell onClick={() => this.selectRow(product, index)}>
                          {pieces}
                        </TableCell>
                        <TableCell onClick={() => this.deleteRow(index)}>
                          <RemoveButton>
                            <RoundClose />
                          </RemoveButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}

export default LocationForm;
